module.exports = __webpack_public_path__ + "static/media/brou.ec0ff006.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brou.jpg
// module id = 485
// module chunks = 0 1 2